import React, { useEffect, useState } from 'react'
import "bootstrap/dist/css/bootstrap.min.css"
import "./weather.css"
import axios from "axios"

const Weather = () => {
    const apiKey = "895284fb2d2c50a520ea537456963d9c"
    const [data, setData] = useState({});
    const [inputCity, setInputCity] = useState("")

    const getWetherDetails = (location) => {
        if (!location) return
        const apiURL = "https://api.openweathermap.org/data/2.5/weather?q=" + location + "&units=imperial&appid=" + apiKey
        axios.get(apiURL).then((res) => {
            console.log("response", res.data)
            setData(res.data)
        }).catch((err) => {
            console.log("err", err);
        })
    }

    const handleChangeInput = (e) => {
        console.log("value", e.target.value)
        setInputCity(e.target.value)
    }

    const handleSearch = () => {
        getWetherDetails(inputCity)
    }

    useEffect(() => {
        getWetherDetails("jaipur")
    }, [])

    return (
        <div className='col-md-12' >
            <div className='wetherBg' >
                <h1>Weather App</h1>
                <div className='d-grid gap-3 col-4 mt-4' >
                    <input type="text" className='form-control'
                        value={inputCity}
                        onChange={handleChangeInput} />
                    <button className='btn btn-primary' type='button'
                        onClick={handleSearch}
                    >Search</button>
                </div>
            </div>
            <div className='col-md-12 text-center mt-5' >
                <div className='shadow rounded wetherResultBox' >
                    <img className='weatherIcon'
                        src='https://i.pinimg.com/originals/77/0b/80/770b805d5c99c7931366c2e84e88f251.png' alt='' />
                    <h5 className='weathorCity' >
                        {data?.name}
                    </h5>
                    <h6 className='weathorTemp' >{((data?.main?.temp - 32) * 5 / 9).toFixed(2)}°C</h6>
                    {/* <h6 className='weathorTemp' >{data?.wind?.speed} </h6> */}
                </div>
            </div>
        </div>
    )
}

export default Weather
